module.exports = __webpack_public_path__ + "static/metallic_dragons-a47eaa4837dcbe20145e260e0c9aeabb.jpg";